import React, {Component} from 'react'
import Header from "../components/header"
import MainNav from "../components/mainNav"
import Footer from "../components/footer"
import api from "../../api/api"
import '../../static/css/style.scss'
import Notdata from "../components/notdata"
import InfiniteScroll from 'react-infinite-scroller'
class Information extends Component {
	state={
		countryList:[],
		countryId:'',
		levelList:[],
		levelId:'',
		currentPage:1,
		pageSize:20,
		school:'',
		list:[],
		finished:false,
		hasMore:true,
		navs:[
			{name:'首页',link:'/'},
			{name:'留学资讯',link:'/information'},
		]
	}
	componentDidMount() {
		this.getSelectList()
		this.getList()
	}
	getSelectList=async ()=>{
		let res= await api.get('/news/get-type')
		res.data.country.unshift({id:'',value:'不限'})
		res.data.category.unshift({id:'',name:'不限'})
		// console.log(res.data)
		this.setState({
			countryList:res.data.country,
			levelList:res.data.category
		})
	}
	getList=async ()=>{
		let {countryId,levelId,currentPage,pageSize,school,list,finished}=this.state
		if (finished){
			return
		}
		let res=await api.get('/news/get-list',{
			country:countryId,cate:levelId,currentPage,pageSize,school
		})
		let temp=[]
		if (currentPage===1){
			temp=res.data.data
		}else {
			temp=[...list,...res.data.data]
		}
		this.setState({
			list:temp,
		},()=>{
			let total=res.data.total
			if (this.state.list.length>=total){
				this.setState({hasMore:false,finished:true})
			}else {
				this.setState({hasMore:true})
			}
		})
	}
	render() {
		let {countryList,countryId,levelList,levelId,list,navs,hasMore,currentPage}=this.state
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<MainNav navs={navs}/>
					<div className={'case-select'}>
						<div className={'case-select-item'}>
							<div className={'category'}>请选择国家：</div>
							<div className={'category-list'}>
								{
									countryList.map((item,index)=>(
										<div className={['category-list-item',countryId===item.id?'on':null].join(' ')}  key={index} onClick={()=>{
											this.setState({countryId:item.id,currentPage: 1,finished:false},()=>{
												this.getList()
											})
										}}>{item.value}</div>
									))
								}
							</div>
						</div>
						<div className={'case-select-item'}>
							<div className={'category'}>请选择分类：</div>
							<div className={'category-list'}>
								{
									levelList.map((item,index)=>(
										<div className={['category-list-item',levelId===item.id?'on':null].join(' ')}  key={index} onClick={()=>{
											this.setState({levelId:item.id,currentPage: 1,finished:false},()=>{
												this.getList()
											})
										}}>{item.name}</div>
									))
								}
							</div>
						</div>
					</div>
					{
						list.length?(<div className={'info-list'}>
							<InfiniteScroll
								hasMore={hasMore}
								useWindow={true}
								initialLoad={false}
								loadMore={()=>{
									currentPage++
									this.setState({currentPage,hasMore:false},()=>{
										this.getList()
									})
								}}
							>
								{
									list.map((item,index)=>(
										<div className={'info-item'} key={index} onClick={()=>{this.props.history.push('/informationdetail/'+item.id)}}>
											<div className={'info-img'}>
												<img src={item.image} alt=""/>
											</div>
											<div className={'info-text'}>
												<div className={'info-title'}>{item.title}</div>
												<div className={'info-jianjie'}>{item.summary}</div>
												<div className={'info-label'}><img src={require('../../static/images/shu.png')} alt=""/> <span className={'span'}>{item.country_text}_</span><span>{item.category_text}</span> </div>
											</div>
										</div>
									))
								}
							</InfiniteScroll>
						</div>):<Notdata/>
					}
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Information